import React from "react";
import { IconPhone, IconMail } from "../../assets/icons/Icon";
import { SectionHeader } from "../../styles/Typography";
import { contacts } from "./contacts.data";
import { scrollTo } from "../../hooks/scrollTo";
import {
  OuterContainer,
  ContactsHeader,
  ContactsContainer,
  Contact,
  ContactName,
  ContactInfo,
  ContactLink,
  ActionContainer,
  DesktopActionButton,
  ResponsiveActionButton,
} from "./Contacts.styled";

const Contacts: React.FC = () => {
  const scrollToApplication = () => {
    scrollTo("application");
  };

  return (
    <OuterContainer>
      <ContactsHeader>
        <SectionHeader>Контакты</SectionHeader>
      </ContactsHeader>

      <ContactsContainer>
        {contacts.map((contact) => (
          <Contact key={contact.email}>
            <ContactName>
              <h3>{contact.name}</h3>
              <p>{contact.role}</p>
            </ContactName>

            <ContactInfo>
              <ContactLink href={`mailto:${contact.email}`}>
                <IconMail aria-hidden="true" />
                <span>{contact.email}</span>
              </ContactLink>
              <ContactLink href={`tel:${contact.phone.replace(/[^+\d]/g, "")}`}>
                <IconPhone aria-hidden="true" />
                <span>{contact.phone}</span>
              </ContactLink>
            </ContactInfo>
          </Contact>
        ))}
      </ContactsContainer>

      <ActionContainer>
        <DesktopActionButton onClick={scrollToApplication}>
          <span>Связаться с нами</span>
          <i className="pi pi-arrow-up-right" aria-hidden="true" />
        </DesktopActionButton>
        <ResponsiveActionButton variant="arrow" onClick={scrollToApplication}>
          Связаться с нами
        </ResponsiveActionButton>
      </ActionContainer>
    </OuterContainer>
  );
};

export default Contacts;
